const NumberConfig = (number = "", action) => {
  switch (action.type) {
    case "GET_NUMBER":
      return action.playload;
    default:
      return number;
  }
};
export default NumberConfig;
